import React, { useState, useEffect } from 'react'
import { Outlet, useParams, useNavigate } from 'react-router-dom'
import Tabs from './tabs-menu'
import { useGame } from 'data/hooks'

import { EventsMenu } from 'basecomps'

export const Events = props => {

  const params = useParams()
  const eventType = props.eventType || params.eventType
  const { eventId } = params
  const gameId = useParams().gameId || playmotiv.game.gameId
  const { getEventsByType } = useGame(gameId)
  const events = getEventsByType(eventType)
  const navigate = useNavigate()
  
  useEffect(() => {
    
    if(eventId === undefined) {
    
      if (events.length > 0) {

        const actualEvent = events.find(e => e.instance && e.instance.start && !e.instance.end)

        if(!actualEvent) {

          navigate(`./${events[0].eventId}`)

        } else {

          navigate(`./${actualEvent.eventId}`)
        }

      } else if (events.length === 1) {

        navigate(`./${events[0].eventId}`)
      }

    } else {

      // se comenta la siguiente línea porque hace que el player entre en bucle
      // si existe el parámetro eventId, es que ya está en una ruta (quizás inferior)
      // y no hace falta navegar 
      // navigate(`./${eventId}`)
    }

  }, [events])

  return (
    <div 
      className={`
        events
        ${ !props.nomenu && events.length > 1 ? 'with-menu' : '' }
        ${ eventType.replace('.', '-') }
      `}
    >
      { 
        !props.nomenu &&
        events.length > 1 &&
        <div className="events-menu"><EventsMenu events={events} {...props} /></div>
      }
      { 
        events.length === 0 ?
        <div className="no-events">En estos momentos no hay ningún evento para esta sección</div>
        :
        <div className="events-wrapper">
          <Outlet />
        </div>
      }
    </div>
  )
}
